import React from 'react';
import styled from 'styled-components';
import InterviewIcon from '../../icons/InterviewIcon';
import DogIcon from '../../icons/DogIcon';
import { Link, navigate } from '@reach/router';
import hlidac from '../../icons/hlidac.jpg';
import konzultace from '../../icons/konzultace.jpg';

export default function Services() {
  return (
    <PageContrainer>
      <h1>Služby pro bytové domy</h1>
      <ContentBox>
        <Box>
          <IconContainer>
            <InterviewIcon />
          </IconContainer>
          <h3>Bezplatná konzultace záměru a jeho financování</h3>
          <TextBox>
            <h4>Připravujete rekonstrukci domu, ale zatím není jistý záměr?</h4>
            <p>
              Nevadí, rádi Vám poskytneme bezplatnou konzultaci a projdeme s Vámi možnosti financování, vazby
              financování na průběh rekonstrukce a vhodné nastavení produktů.
            </p>
          </TextBox>
          <MeatingBox onClick={() => navigate('/konzultace')}>
            <h3>Sjednat konzultaci</h3>
            <Link to='/konzultace'>
              <Text>
                <p>Objednejte se</p>
              </Text>
            </Link>
            <MoneyPic src={konzultace} />
          </MeatingBox>
        </Box>
        <Box>
          <IconContainer>
            <DogIcon />
          </IconContainer>
          <h3>Hlídač konce fixace</h3>
          <TextBox>
            <h4>Splácíte starší úvěr poskytnutý na rekonstrukci domu a nechce se Vám to dále řešit?</h4>
            <p>
              Nevadí, stačí se domluvit s námi. Ohlídáme Vám konec fixace úrokové sazby a včas
              Vám připravíme nabídky na refinancování úvěru.
            </p>
          </TextBox>
          <MeatingBox onClick={() => navigate('/hlidac')}>
            <h3>Nastavit hlídání</h3>
            <Link to='/hlidac'>
              <Text>
                <p>Nastavte</p>
              </Text>
            </Link>
            <MoneyPic src={hlidac} />
          </MeatingBox>
        </Box>
      </ContentBox>
    </PageContrainer>
  );
}

const MoneyPic = styled.img`
  width: 100%;
  border-radius: 0 0 15px 15px;
  margin-bottom: -1px;
`;
const Text = styled.div`
  position: absolute;
  left: 50%;
  bottom: -1px;
  transform: translate(-50%,0);
  background: rgba(255,0,0, .6);
  padding: 0 12px;

  p {
    text-transform: uppercase;
    color: ${({ theme }) => theme.palette.common.black};
    font-weight: 600;
  }
`;
const MeatingBox = styled.div`
  width: 100%;
  max-width: 320px;
  text-align: center;
  border-radius: 15px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.5);
  margin: 0 36px;
  position: relative;
  transition: all .6s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  h3 {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 12px 0 !important;
  }

  &:hover {
    transform: scale(1.1);
    @media(max-width: 650px) {
      transform: scale(1);
    }
  }
  @media(max-width: 450px) {
    margin: 24px 0;
  }

`;

const TextBox = styled.div`
  width: 100%;
  min-height: 200px
  text-align: justify;
  padding-bottom: 24px;
`;

const PageContrainer = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
`;

const IconContainer = styled.div``;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 24px;
  width: 50%;

  @media(max-width: 950px) {
    width: 100%;
    padding: 12px 0 48px 0;
  }

  h3 {
    background: ${({ theme }) => theme.palette.primary.light2};
    padding: 6px 12px;
    width: 100%;
    text-align: center;
    margin-bottom: 24px;
    box-shadow: 1px 12px 24px ${({ theme }) => theme.palette.black.light};
  }
`;

const ContentBox = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  padding: 6px 0 48px 0;
`;
